import { getInputClass } from "@/common/components/input/input.styles";

import type { InputProps } from "./input.types";

function Input({ ref, className, type, ...props }: InputProps) {
  return <input ref={ref} type={type} className={getInputClass({ className })} {...props} />;
}
Input.displayName = "Input";

export { Input };
